<template>
  <div>
    <div class="race-schedule-list">
      <div class="race-schedule-item" :class=" hasPerms(item.authorityFlag) ? '' : 'no-permission'"
        v-for="(item, index) in list"
        :key="index"
        @click="scheduleCardTap(item)">
        <div class="race-schedule-item-bg"></div>
        <div class="race-schedule-item-h1">{{ item.scheduleName }}</div>
        <!-- <div class="race-schedule-item-h2">
          {{index === 0 ? $t('h.preliminaryCompetition') : index === 1 ? $t('h.divisionFinals') : index === 2 ? $t('h.nationalFinals') : ''}}
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
// import { hasPermission } from '@/permission/index.js'

export default {
  props: {
    list: {
      type: Array
    }
  },
  data () {
    return {
    }
  },
  methods: {
    // 赛程点击事件
    scheduleCardTap (item) {
      // console.log('e', item)
      if (!this.hasPerms(item.authorityFlag)) {
        return this.$message.warning('暂无操作权限')
      }
      if (item.showPop) {
        this.$emit('showNational')
        return
      }
      if (item.path) {
        const query = {}
        if (item.scheduleFlag) {
          query.scheduleFlag = item.scheduleFlag
        }
        if (item.raceSchedule !== undefined) {
          query.raceSchedule = item.raceSchedule
        }
        this.$router.push({
          path: item.path,
          query: query
        })
      }
    },
    hasPerms: function (_flag) {
      // 根据权限标识和外部指示状态进行权限判断
      return true
      // return hasPermission(_flag) // & !this.disabled
    }
  }
}
</script>
<style scoped lang="less">

.title_row {
  /* border-bottom: 2px solid #eee; */
  padding-bottom: 5px;
  margin-bottom: 15px;
}
.title_class {
  display: flex !important;
  align-items: center;

  &:before {
    display: block;
    content: '';
    width: 3px;
    height: 18px;
    border-radius: 3px;
    background-color: #409EFF;
    margin-right: 6px;
  }
}
</style>
